import Stock from '@/models/item/stock'
import DisplayStockIsFew from './each-case/display-stock-is-few'
import DisplayStockIsSome from './each-case/display-stock-is-some'
import HlWebStockIsSome from './each-case/hl-web-stock-is-some'
import WebStockIsFew from './each-case/web-stock-is-few'
import WebStockIsSome from './each-case/web-stock-is-some'

export default interface DisplayRule {
  shouldApply(stock: Stock): boolean
  apply(stock: Stock): string
}

// TODO: 静的ではなく、ルール毎に定義
export function ruleIsOnFew(rule: DisplayRule): boolean {
  return [
    WebStockIsSome,
    WebStockIsFew,
    HlWebStockIsSome,
    DisplayStockIsSome,
    DisplayStockIsFew,
  ].some(ruleType => rule instanceof ruleType)
}
